// Auto-scrolls any <slider-component> marked data-autoplay-carousel="true".
// Dawn's own SliderComponent has no autoplay (that's only on the slideshow
// section used for hero banners), so this drives the existing scroll container.
//
// Deliberately NO cloning: an earlier version cloned the items to make a
// seamless infinite loop, but with a small product count the clones are
// visible immediately and read as duplicated products. Instead this scrolls
// forward one item at a time and, on reaching the end, jumps back to the
// start — so every product appears exactly once, never duplicated.
(function () {
  function initAutoplay(root) {
    const track = root.querySelector('[id^="Slider-"]');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length < 2) return;

    const itemOffset = items[1].offsetLeft - items[0].offsetLeft;
    if (!itemOffset) return;

    // Only autoplay when the row actually overflows its viewport; a row whose
    // products all fit has nothing to scroll.
    if (track.scrollWidth <= track.clientWidth + 4) return;

    const speed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;
    let paused = false;

    function atEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function step() {
      if (paused) return;
      if (atEnd()) {
        // Instant jump back to the start (no animated rewind across all items).
        const prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = 0;
        track.style.scrollBehavior = prev;
      } else {
        // Forward step; CSS scroll-behavior: smooth animates it.
        track.scrollLeft += itemOffset;
      }
    }

    const timer = setInterval(step, speed);

    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) =>
      root.addEventListener(evt, () => { paused = true; })
    );
    ['mouseleave', 'focusout', 'touchend'].forEach((evt) =>
      root.addEventListener(evt, () => { paused = false; })
    );

    root.addEventListener('remove', () => clearInterval(timer));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-autoplay-carousel="true"]').forEach(initAutoplay);
  });
})();
